<ng-container
    *ngIf="{
  row: columnData | async,
  adata: additionData | async
} as $"
>
<p-button *ngIf="canShowRetry($.row)" icon="fa fa-angle-down" [label]="'common.BUTTONS.BTN_ACTIONS' | translate" iconPos="right"
styleClass="p-overlayPanel-trigger surface-0 p-button-outlined border-300 ml-2 text-600 text-sm" (click)="action.toggle($event)"></p-button>
    <p-popover #action styleClass="overflow-hidden text-sm w-10rem -ml-5">
        <ng-template #content>
            <ul class="list-none -m-4 py-2 px-0 text-xs text-600">
                <li *ngIf="$.adata.includes('retrypayment') && canShowRetry($.row)"
                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                (click)="executeAction('retrypayment',$.row,action)">
                <i class="fa fa-rotate-left mr-2"></i>{{ 'ADMIN.COMMON.RETRY_PAYMENT' | translate }}
              </li>
            </ul>
        </ng-template>
    </p-popover>
</ng-container>
